import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface CvPortalJob {
  idVacancy: number | null;
  idRecruitment: number | null;
  idFirm: number;
  idDepartment: number;
  idCustomer: number;
  idMunicipality: number;
  idCounty: number;
  idPositionType: number;
  firm: string;
  department: string;
  customer: string;
  municipality: string;
  county: string;
  workplace: string;
  anonymousCustomer: boolean;
  applicationDeadline: string | null;
  positionType: string;
  positionForm: string;
  positionTypeCategory: string;
  positionTypeFreeText: string;
  numPositions: number;
  publishDate: string | null;
  urlLogo: string;
  adrDepartment: string | null;
  fromDateText: string | null;
  jobTitle: string | null;

  // added on frontend
  key?: string;
  favorite?: boolean;
  favoriteKey?: string;
}

export interface GetJobsResponse extends BackendResponse {
  items: CvPortalJob[];
}

export interface GetJobsParameters extends NextApiParams {
  idFirm?: number; // deprecated - use idDepartments
  idDepartment?: number; // deprecated - use idDepartments
  idDepartmentFocused?: number; // deprecated - use idDepartments
  includeVacancies: boolean;
  includeRecruitments: boolean;
  idDepartments?: number[];
}

export const getJobs = withNextApi<GetJobsResponse, GetJobsParameters>(
  "/cvp/CvpGetJobs",
  { method: "GET" }
);
